class AlertService {
  constructor($window) {
    $window.Messenger.options = {
      extraClasses: 'messenger-fixed messenger-on-bottom messenger-on-left',
      theme: 'flat',
      showCloseButton: true
    };

    this._messenger = $window.Messenger({});
  }

  /**
   * @method info
   * @desc create an info alert
   * @param {String} msg
   */
  info(msg) {
    if (!msg) throw new Error('alertService - info() - msg is required');

    this._messenger.post({
      message: msg,
      type: 'info',
      showCloseButton: true
    });
  }

  /**
   * @method alert
   * @desc create a success alert
   * @param {String} msg
   */
  success(msg) {
    if (!msg) throw new Error('alertService - success() - msg is required');

    this._messenger.post({
      message: msg,
      type: 'success',
      showCloseButton: true
    });
  }

  /**
   * @method error
   * @desc create an error alert
   * @param {String} msg
   */
  error(msg) {
    if (!msg) throw new Error('alertService - error() - msg is required');

    this._messenger.post({
      message: msg,
      type: 'error',
      showCloseButton: true
    });
  }
}

AlertService.$inject = [
  '$window'
];

export default AlertService;



// WEBPACK FOOTER //
// ./src/services/alertService.js